import { createFileRoute } from '@tanstack/react-router'
import { AiSettingsPage } from '@/features/ai-usage/ai-settings-page'

export const Route = createFileRoute('/settings/ai')({
  component: AiSettingsPage,
})
